<template>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="success"
        >
          <v-toolbar-title>Create Sub Task</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container fluid grid-list-lg>
          <v-toolbar class='py-2 mb-3 task_page__toolbar'>
            <v-toolbar-title class='caption '>
              <div>
                <v-textarea
                  hide-details
                  class="ma-0 pa-0"
                  v-model="task.title"
                  ref="title"
                  solo
                  auto-grow
                  rows="1"
                ></v-textarea>
                <div class="text-xs-right" :style="{ color: !canSave ? 'red' : '' }">
                  {{ task.title.length }} / 190
                </div>
              </div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn :disabled="!canSave" class="my-0" color="success" @click="create">save</v-btn>
          </v-toolbar>
          <progress-bar></progress-bar>
          <v-layout wrap mt-2>
            <v-flex sm12 md8>
              <drop-zone @paste="(file) => {task.attachments.push(file)}">
                <v-card>
                  <v-card-text>
                    <div class='sl_form_title'>
                      <h3>
                    <span class="sl_form_title--project-name">
                      Project: <strong>{{ project | getText('name', 'without project') }}</strong><br>
                    </span>
                        Description task
                      </h3>
                    </div>
                    <v-divider class='my-2'></v-divider>
                    <markdown
                      :editing="true"
                      label="Article text"
                      v-model="task.text"
                    />
                  </v-card-text>
                </v-card>
              </drop-zone>
            </v-flex>
            <v-flex sm12 md4>
              <v-card>
                <v-card-text>
                  <div class='sl_form_title align-center'>
                    <h3>Management</h3>
                  </div>
                  <v-divider class='my-2'></v-divider>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select item-text="name" label="Status" item-value="id" hide-details
                                v-model="task.column_id" :items="columns"></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-select multiple label="Assignee(s)" item-text="name" deletable-chips
                                hide-details
                                class="pa-0" chips
                                v-model="task.instance_users" return-object :items="instance_users"></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12>
                      <div class="task_page__list--labels">
                        <v-select multiple item-text="name" label="Labels" deletable-chips hide-details
                                  class="pa-0" chips
                                  v-model="task.labels" return-object :items="labels"></v-select>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex xs12>
                      <div class="task_page__list--labels">
                        <v-text-field label="External link" class="pa-0"
                                      v-model="task.external_link"></v-text-field>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12>
                      <div class="task_page__list--labels">
                        <div class="tasks_page__list--item_chip">{{ parentTask.short_name }}</div>
                        <strong>{{ parentTask.title }}</strong>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card class="mt-3" xs4 v-if="task.attachments.length">
                <v-card-text>
                  <v-layout>
                    <v-flex xs12>
                      <div class='sl_form_title'>
                        <h3>Attached files</h3>
                      </div>
                      <v-divider class='my-2'></v-divider>
                      <div v-for="(file, index) in task.attachments" :key="index">
                        <v-layout wrap>
                          <v-flex>
                            <a :href="$baseURL + file.url" target="_blank">{{ file.name }}</a>
                          </v-flex>
                          <v-btn icon small @click="removeAttachment(index)">
                            <v-icon size="18">delete</v-icon>
                          </v-btn>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
</template>

<script>
import progress from "@/components/progress"
import drop from "@/components/drop";
import markdown from '@/components/markdown'
import * as mixins from "@/mixins";

export default {
  name: "FormSubTask",
  mixins: [mixins.preloader],
  components: {
    "progress-bar": progress,
    'drop-zone': drop,
    'markdown': markdown,
  },
  props: {
    parentTask: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      dialog: false,
      task: {
        title: '',
        text: '',
        external_link: '',
        attachments: [],
        files: []
      },
      columns: [],
      instance_users: [],
      labels: [],
      project: {}
    }
  },
  computed: {
    canSave() {
      return this.task.title.length <= 190
    }
  },
  methods: {
    async toggle() {
      this.dialog = true
      await this.getProject()
      this.task.project_id = this.project.id
      this.task.parent_id = this.parentTask.id
    },
    getProject() {
      return this.$api.projects.get(this.parentTask.project_id).then(({data}) => {
        let instance_users = data.instance_users.concat(data.instance_user)
        this.labels = data.labels
        this.instance_users = instance_users
        this.project = data
        this.columns = data.columns
      }, err => {
        console.log('pages/projects/tasks/form.vue getProject', err)
      })
    },
    removeAttachment(index) {
      this.task.attachments.splice(index, 1)
    },
    paste(file) {
      this.task.attachments.push(file)
    },
    create() {
      this.background(this.saveTask())
    },
    saveTask() {
      return this.$api.tasks.save(this.task).then(({data}) => {
        this.task = {
          ...this.task,
          ...data,
          project: this.project
        }
        this.$notify({
          group: 'success',
          type: 'success',
          text: 'Saved'
        })

        this.$emit('refresh')
        this.close()
      }, err => {
        console.log('pages/projects/tasks/form.vue saveTask', err)
      })
    },
    close() {
      this.task = {
        title: '',
        text: '',
        external_link: '',
        attachments: [],
        files: []
      }
      this.dialog = false
    }
  }
}
</script>
